import { merge } from 'lodash';

import { buildCloudPayQuery } from '../utils/query';

const mergeTransactionsEntities = (prev = {}, next = {}) => ({
  ...prev,
  ...next,
  ...(next.all !== undefined ? { all: next.all } : {})
});

/**
 * @description Get a transaction by order
 *
 * @param {Object} [options]
 * @returns {QueryConfig}
 */
export const getTransactionByOrderId = buildCloudPayQuery(
  ({ orderId }) => ({
    url: `/transactions/${orderId}`,
    update: {
      transaction: merge
    }
  })
);

export const getAlltransactions = buildCloudPayQuery(
  () => ({
    force: true,
    url: `/transactions/allFromUser`,
    options: {
      method: 'GET'
    },
    transform: (data) => ({
      transactions: {
        all: data
      }
    }),
    update: {
      transactions: mergeTransactionsEntities
    }
  })
);